import { AbortFlowException2zdgh4w7z3hep as AbortFlowException } from './internal/FlowExceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { checkOwnershipoyid8o0pxxr7 as checkOwnership } from './internal/FlowExceptions.common.mjs';
import { ensureActive2yo7199srjlgl as ensureActive } from '../Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function takeWhile(_this__u8e3s4, predicate) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (takeWhile$$inlined$unsafeFlow$1())(_this__u8e3s4, predicate);
}
var takeWhile$$inlined$unsafeFlow$1$collect$2Class;
function takeWhile$$inlined$unsafeFlow$1$collect$2() {
  if (takeWhile$$inlined$unsafeFlow$1$collect$2Class === VOID) {
    class $ {
      constructor($predicate, $$this$flow) {
        this.m1h_1 = $predicate;
        this.n1h_1 = $$this$flow;
      }
      *a1h(value, $completion) {
        var tmp;
        if (yield* this.m1h_1(value, $completion)) {
          yield* this.n1h_1.r1d(value, $completion);
          tmp = true;
        } else {
          tmp = false;
        }
        if (!tmp) {
          throw AbortFlowException().o1h(this);
        }
        return Unit_instance;
      }
      r1d(value, $completion) {
        return this.a1h(value, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [FlowCollector()], [1]);
    takeWhile$$inlined$unsafeFlow$1$collect$2Class = $;
  }
  return takeWhile$$inlined$unsafeFlow$1$collect$2Class;
}
var takeWhile$$inlined$unsafeFlow$1Class;
function takeWhile$$inlined$unsafeFlow$1() {
  if (takeWhile$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_takeWhile, $predicate) {
        this.p1h_1 = $this_takeWhile;
        this.q1h_1 = $predicate;
      }
      *q1d(collector, $completion) {
        // Inline function 'kotlinx.coroutines.flow.collectWhile' call
        var this_0 = this.p1h_1;
        var collector_0 = new (takeWhile$$inlined$unsafeFlow$1$collect$2())(this.q1h_1, collector);
        try {
          yield* this_0.z1c(collector_0, $completion);
        } catch ($p) {
          if ($p instanceof AbortFlowException()) {
            var e = $p;
            checkOwnership(e, collector_0);
            // Inline function 'kotlin.js.getCoroutineContext' call
            var tmp$ret$2 = $completion.mc();
            ensureActive(tmp$ret$2);
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      z1c(collector, $completion) {
        return this.q1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    takeWhile$$inlined$unsafeFlow$1Class = $;
  }
  return takeWhile$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  takeWhile as takeWhile2lajz05xm93j8,
};
//endregion

//# sourceMappingURL=Limit.mjs.map
